import { useMutation } from '@tanstack/react-query';
import { setHealthProfileModuleOnboardingComplete } from '@leagueplatform/assessment-api';

export const useCompleteOnboarding = (moduleId: string) =>
  useMutation(() => setHealthProfileModuleOnboardingComplete(moduleId));
